module.exports = __webpack_public_path__ + "images/fordon-batar-delar.c45c693d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/fordon-batar-delar.jpg
// module id = 85987099
// module chunks = 6 16